import type { BookProgress, BookType, CEFRLevels } from '../Book'
import { LogoutAction } from '../User'
import { Routine, Sections, TutorProfile } from '../Lesson'

export enum LearningJourneyEntityType {
  // -------------------------------------- //
  // --------------- REMOTE --------------- //
  // -------------------------------------- //

  Book = 'book',
  Checkpoint = 'checkpoint',
  StudySet = 'study-set',
  FinishedStudySet = 'finished-study-set',
  PowerUp = 'power-up',
  TutorVideoMessage = 'tutor-video-message',
  LevelUp = 'level-up',

  // -------------------------------------- //
  // -------------- HARDCODED ------------- //
  // -------------------------------------- //

  Timer = 'timer',
  Greeting = 'greeting',
  IntroStory = 'intro-story',
  PlacementTest = 'placement-test'
}

export type LearningJourneyEntity = (
  | { type: LearningJourneyEntityType.Book; data: JourneyBook }
  | { type: LearningJourneyEntityType.Checkpoint; data: { index: number } }
  | {
      type: LearningJourneyEntityType.StudySet
      data: StudySetData
    }
  | {
      type: LearningJourneyEntityType.FinishedStudySet
      data: {
        title: string
        imageUrl: string
        points: number
        sections: Sections
      }
    }
  | {
      type: LearningJourneyEntityType.PowerUp
      data: PowerUpData
    }
  | {
      type: LearningJourneyEntityType.TutorVideoMessage
      data: TutorVideoMessageData
    }
  | {
      type: LearningJourneyEntityType.LevelUp
      data: {
        subtype: 'sentence' | 'word-builder'
      }
    }
) & { attributes: LearningJourneyEntryAttributes }

export interface JourneyBook {
  title: string
  bookId: string
  points: number
  type: BookType
  cefrLevel: CEFRLevels
  progress?: BookProgress
}

export interface JourneyState {
  timeSpent: number
  dailyGoal: number
  isDailyGoalAchieved: boolean
}

export enum JourneyServiceActionTypes {
  AsyncGetTimeSpent = 'Journey/async_get_time_spent'
}

export enum LearningJourneyCoverLabel {
  GIFT = 'gift',
  UNAVAILABLE = 'unavailable'
}

export type LearningJourneyEntryAttributes = {
  coverLabel?: LearningJourneyCoverLabel
  // postPaywall?: Paywall.Config
  isUnavailable?: boolean
}

export type AsyncGetTimeSpentAction = {
  type: JourneyServiceActionTypes.AsyncGetTimeSpent
  timeSpent: number
}

export type JourneyServiceAction = AsyncGetTimeSpentAction | LogoutAction

export type StudySetData = {
  title: string
  imageUrl: string
  points: number
  sections: Sections
  progress?: { current: number; total: number }
} & ({ routine: Routine } | { routineAccessToken: string })

export type PowerUpData = {
  title: string
  imageUrl: string
  progress?: { current: number; total: number }
  points: number
} & ({ routine: Routine } | { routineAccessToken: string })

export type TutorVideoMessageData = {
  title: string
  tutorProfile: TutorProfile
  imageUrl: string
  progress: { current: number; total: number }
} & ({ routine: Routine } | { routineAccessToken: string })

export interface GetStoriesPayload {
  skip: number
  limit: number
  storiesType: 'past' | 'future'
}
